// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-group[data-v-648c13a4]{position:relative}.container-group .remove[data-v-648c13a4]{position:absolute;top:-40px;right:5px}.container-group .row[data-v-648c13a4]:not(:first-child){margin-top:20px}", ""]);
// Exports
module.exports = exports;
